var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-modal",
    { attrs: { value: _vm.modalState.isOpen() } },
    [
      _vm.modalState.isOpen()
        ? _c(
            "w-card",
            { attrs: { "max-width": "700" } },
            [
              _c("w-card-title", [_vm._v(_vm._s(_vm.title))]),
              _c(
                "w-scroll-view",
                { attrs: { tag: "w-card-content" } },
                [
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("w-textarea", {
                            attrs: {
                              height: "500",
                              disabled: _vm.modalState.isSaving,
                              placeholder: _vm.$ct("common.info"),
                            },
                            model: {
                              value: _vm.modalState.text,
                              callback: function ($$v) {
                                _vm.$set(_vm.modalState, "text", $$v)
                              },
                              expression: "modalState.text",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "w-card-actions",
                [
                  _c(
                    "w-button",
                    {
                      staticClass: "cancel",
                      attrs: { disabled: _vm.modalState.isSaving, icon: "ban" },
                      on: {
                        click: function ($event) {
                          return _vm.modalState.cancel()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$ct("common.cancel")))]
                  ),
                  _c("w-spacer"),
                  _c(
                    "w-button",
                    {
                      attrs: {
                        disabled: _vm.modalState.isSaving,
                        icon: "save",
                      },
                      on: {
                        click: function ($event) {
                          _vm.modalState.save(), _vm.save()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$ct("common.save")))]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }